/**
 * The status bar at the bottom, like Unreal Engine's: the Assets drawer button on the left
 * (Unreal's content drawer, Ctrl+Space), the Log window's switch, then the graph's counts and
 * the connection to the core on the right.
 */
import { Show, type JSX } from "solid-js";
import { useApp } from "./context";
import { isOpen } from "../wm/layout";
import { Icon } from "../shared/icons";

/** The status bar. */
export function StatusBar(): JSX.Element {
  const { graph, client, presets, wm } = useApp();
  /** The connection state: open, connecting, closed or refused. */
  const status = () => client.status();
  return (
    <footer class="statusbar" id="statusbar">
      <button
        type="button"
        class="sb-button pdrawer-button"
        id="preset-drawer-button"
        aria-expanded={presets.drawer()}
        title="Assets drawer: files and presets (Ctrl+Space)"
        onClick={() => presets.setDrawer(!presets.drawer())}
      >
        <Icon name="presets" size={15} />
        Assets
      </button>
      <button type="button" class="sb-button" id="log-toggle" aria-pressed={isOpen(wm.layout(), "log")} title="Show or hide the Log window" onClick={() => wm.toggle("log")}>
        <Icon name="log" size={15} />
        Log
      </button>
      <span class="sb-fill" />
      <span class="stats" id="stats">
        <Show when={graph.state.loaded}>
          {graph.state.graph.nodes.length} nodes · {graph.state.graph.links.length} links · rev {graph.state.revision}
        </Show>
      </span>
      <span class="conn" data-status={status()} title={`Core connection: ${status()}`}>
        <i />
        {{ open: "connected", connecting: "connecting…", closed: "offline", refused: "no access" }[status()]}
      </span>
    </footer>
  );
}
